import React from 'react';
import { PenToolIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-950 py-12 border-t border-slate-800" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-114">
          <div className="flex items-center gap-2" data-id="element-115">
            <div className="bg-blue-900 text-white p-1.5 rounded-md" data-id="element-116">
              <PenToolIcon className="w-4 h-4" data-id="element-117" />
            </div>
            <span className="text-lg font-bold text-white tracking-tight" data-id="element-118">
              Valley Notary <span className="text-blue-500" data-id="element-119">Pro</span>
            </span>
          </div>

          <div className="text-slate-400 text-sm text-center md:text-left" data-id="element-120">
            <p data-id="element-121">
              Directory of trusted{' '}
              <strong className="text-slate-300 font-medium" data-id="element-122">
                notary public services in Fresno, California
              </strong>
              .
            </p>
            <p className="mt-1" data-id="element-123">
              &copy; {currentYear} Notary Public Fresno. All rights reserved.
            </p>
          </div>

          <div className="flex gap-6 text-sm text-slate-400" data-id="element-124">
            <a href="#" className="hover:text-white transition-colors" data-id="element-125">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-126">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}